export enum eTipoContato {
  EMAIL = 'E',
  TELEMOVEL = 'T'
};